import { QUESTION_TYPE_DEFINITIONS, type QuestionType } from 'inspection-types';

export type QuestionTypeIcon =
  | 'rating'
  | 'choice'
  | 'checklist'
  | 'text'
  | 'numeric'
  | 'date'
  | 'list'
  | 'observation'
  | 'unknown';

export type QuestionTypeDisplay = {
  displayName: string;
  icon: QuestionTypeIcon;
};

const ICON_BY_QUESTION_TYPE: Record<QuestionType, QuestionTypeIcon> = {
  rating_5_point: 'rating',
  rating_3_point: 'rating',
  pass_fail: 'choice',
  ok_deficient: 'choice',
  yes_no: 'choice',
  condition_action: 'choice',
  checklist: 'checklist',
  text_only: 'text',
  numeric: 'numeric',
  date: 'date',
  select: 'list',
  multi_select: 'list',
  observation: 'observation',
};

function isKnownQuestionType(
  questionType: string
): questionType is QuestionType {
  return Object.hasOwn(QUESTION_TYPE_DEFINITIONS, questionType);
}

// Accepts any string: a newer server can send a type this client does not know yet
export function getQuestionTypeDisplay(
  questionType: string
): QuestionTypeDisplay {
  if (!isKnownQuestionType(questionType)) {
    return { displayName: questionType, icon: 'unknown' };
  }

  return {
    displayName: QUESTION_TYPE_DEFINITIONS[questionType].displayName,
    icon: ICON_BY_QUESTION_TYPE[questionType],
  };
}
